<div *ngIf="showIDI">
  <div class="container-fluid">
    <app-header titleText="IDI Admin"></app-header>
    <!--<div>
      <button type="button" id="testNotifications" (click)="testNotifications()">Test WO Notifications</button>
    </div>-->
    <div class="card-deck">
      <div class="card bg-success text-white " (click)="dealerManagement()">
        <div class="card-body">
          <div class="row no-gutters">
            <div class="col">
              <img class="mt-3 bg-submit" src="assets/img/circle_images/dealers.png" width="145" />
            </div>
            <div class="col mt-5">
              <h3 class="text-white text-center" i18n>DEALERS</h3>
            </div>
          </div>
          <div class="card-body" i18n>
            Dealers are unique business entities. Dealers must be set up before
            customers can use the tool
          </div>
        </div>
      </div>
      <div class="card bg-dark text-white " (click)="userManagement()">
        <div class="card-body">
          <div class="row no-gutters">
            <div class="col">
              <img class="mt-2" src="assets/img/circle_images/customer_circle.png" width="130" />
            </div>
            <div class="col mt-5">
              <h3 class="text-white" i18n>USERS</h3>
            </div>
          </div>
          <div class="card-body" i18n>
            Users define people that have
            been granted access to the
            admin portal for idi-bidit.com
          </div>
        </div>
      </div>
      <div class="card bg-faqs-light text-white" (click)="faqsManagement()">
        <div class="card-body">
          <div class="row no-gutters">
            <div class="col">
              <img class="mt-2" src="assets/img/admin/faq_question.png" width="100" />
            </div>
            <div class="col mt-5">
              <h3 class="text-white">FAQ</h3>
            </div>
          </div>
          <div class="card-body" i18n>
            FAQ define common questions and answers about functionality in the Bidit Application.
          </div>
        </div>
      </div>
      <div class="card bg-black text-white" (click)="releaseManagement()">
        <div class="card-body">
          <div class="row no-gutters">
            <div class="col-5 mt-3 ml-3">
              <span class="material-icons"
                    i18n-matTooltip style="font-size: 80px">settings</span>
            </div>
            <div class="col mt-5">
              <h3 class="text-white" i18n>RELEASE</h3>
            </div>
          </div>
          <div class="card-body" i18n>
            Update release notes and set notifications
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!showIDI">
  <div class="container-fluid">
    <app-header i18n-titleText titleText="DASHBOARD SUMMARY">
    </app-header>
  </div>
  <div class="bidit-alert">{{this.notificationMessage}}</div>
  <div *ngIf="summary.dashboardAlerts && summary.dashboardAlerts.length > 0" class="row w-100 mb-2">
    <div class="card w-100">
      <div class="card-body bg-light">
        <div class="row">
          <div class="col-sm-3" i18n>Alerts:</div>
          <div class="col-sm-9">
            <ul>
              <li *ngFor="let alert of summary.dashboardAlerts" class="bidit-alert">
                {{alert}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row w-100">
    <div class="card w-100 bg-light">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h5 class="float-left">
              <span *ngIf="isSalesperson; else leadSummary" i18n>My Leads</span>
              <ng-template #leadSummary i18n>Leads</ng-template>
            </h5>
            <div class="info-icon"
                 i18n-matTooltip
                 matTooltip="A sales lead is a potential sales contact who expresses interest in your business' product or services.  Customer information must be added before a lead is entered."></div>
          </div>
          <div class="col-sm-6">
            <div class="float-right">
              <a *ngIf="canAddLead" (click)="newLead()" class="btn btn-bidit-navigate" i18n>Add New Lead</a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <h7 i18n>Opportunities</h7>
            <div class="card dashboard-score">
              <div class="card-header dashboard-green"></div>
              <div class="card-body dashboard-card">
                <h2>{{summary.leadOpportunities}}</h2>
              </div>
              <div class="card-footer score-card-footer"></div>
            </div>
          </div>
          <div class="col-md-2">
            <h7 i18n>Past Due</h7>
            <div class="card dashboard-score">
              <div class="card-header dashboard-red"></div>
              <div class="card-body dashboard-card">
                <h2>{{summary.leadPastDue}}</h2>
              </div>
              <div class="card-footer score-card-footer"></div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="filter-zone">
              <div class="row">
                <div class="col-sm-2"></div>
                <div class="col-sm-7">
                  <label for="allLeads" i18n>All Leads</label>
                  <input type="checkbox" id="pastDue" name="pastDue"
                         class="bidit-switch m-2"
                         [(ngModel)]="leadFilter.pastDue" #pastDue="ngModel" />
                  <label for="pastDue" i18n>Past Due</label>
                </div>
                <div class="col-sm-3">
                  <button class="btn btn-bidit-action float-right" (click)="applyLeadFilter()" onclick="this.blur();" i18n>Apply Filter</button>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2">
                </div>
                <div class="col-sm-4">
                  <select name="customerId" id="customerId" class="form-control select-bidit"
                          [(ngModel)]="leadFilter.customerId" #customer_AssignedTo="ngModel">
                    <option value="null" selected i18n>Customer Name</option>
                    <option *ngFor="let customer of summarySection?.customers" [ngValue]="customer.customer_ID">{{customer.customer_BusinessName}}</option>
                  </select>
                </div>
                <div class="col-sm-4">
                  <select name="salespersonId" id="salespersonId" class="form-control select-bidit"
                          [(ngModel)]="leadFilter.salespersonId" #salespersonId="ngModel">
                    <option value="" selected i18n>Salesperson</option>
                    <option *ngFor="let salesperson of summarySection?.salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
                  </select>
                </div>
                <div class="col-sm-2">
                </div>
              </div>
              <div class="row">
                <div class="col-sm-2 my-auto" i18n>
                  Expiration Date
                </div>
                <div class="form-inline col-sm-4">
                  <input name="leadStart" class="form-control narrow-input" matInput
                         placeholder="mm/dd/yyyy"
                         [matDatepicker]="startPicker"
                         [(ngModel)]="leadFilter.leadStart" #leadStart="ngModel" />
                  <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                </div>
                <div class="form-inline col-sm-4">
                  <input name="leadEnd" class="form-control narrow-input" matInput
                         placeholder="mm/dd/yyyy"
                         [matDatepicker]="endPicker"
                         [(ngModel)]="leadFilter.leadEnd" #leadEnd="ngModel" />
                  <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                  <mat-datepicker #endPicker></mat-datepicker>
                </div>
                <div class="col-sm-1">
                </div>
              </div>
            </div>

            <mat-table class="table-bidit table-striped" [dataSource]="dataSource"
                       matSort matSortActive="projectName" matSortDirection="asc">
              <ng-container matColumnDef="projectName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Name</mat-header-cell>
                <mat-cell *matCellDef="let lead">
                  <a class="dashboard-link" (click)="viewLead(lead.quote_ID)">
                    {{lead.quote_Name}}
                  </a>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="projectNbr">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Number</mat-header-cell>
                <mat-cell *matCellDef="let lead">
                  {{lead.quote_ProjectNumber}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="customerName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Customer</mat-header-cell>
                <mat-cell *matCellDef="let lead">
                  {{lead.customer?.customer_BusinessName}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="contactName">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Contact</mat-header-cell>
                <mat-cell *matCellDef="let lead">
                  <ng-template [ngIf]="lead.customer.contacts.length > 0">
                    {{lead.customer.contacts[0].contact_FirstName}} {{lead.customer.contacts[0].contact_LastName}}
                  </ng-template>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="customerPhone">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Phone</mat-header-cell>
                <mat-cell *matCellDef="let lead">
                  <ng-template [ngIf]="lead.customer.contacts.length > 0">
                    {{lead.customer.contacts[0].contact_Phone}}
                  </ng-template>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="expirationDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Expiration</mat-header-cell>
                <mat-cell *matCellDef="let lead">
                  {{lead.quote_LeadDueDate | date: 'M/d/yyyy'}}
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="salesperson">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Salesperson</mat-header-cell>
                <mat-cell *matCellDef="let lead">
                  <div>
                    <div *ngFor="let quoteAssignment of lead.quoteAssignments">
                      {{quoteAssignment.assignedTo.firstName}} {{quoteAssignment.assignedTo.lastName}}
                    </div>
                  </div>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns">
              </mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns" style="height: unset"></mat-row>
            </mat-table>

            <mat-paginator [length]="summarySection?.leadCount" [pageSize]="5" [pageSizeOptions]="[5]"></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row w-100 mt-2">
    <div [ngClass]="quoteZoneClass">
      <div class="card">
        <div class="card-body bg-light">
          <div class="row">
            <div class="col-sm-3">
              <h5 class="float-left">
                <span *ngIf="isSalesperson; else quoteSummary" i18n>My Quotes</span>
                <ng-template #quoteSummary i18n>Quotes</ng-template>
              </h5>
              <div class="info-icon"
                   i18n-matTooltip
                   matTooltip="Quotes are potential revenue generating events"></div>
            </div>
            <div class="col-sm-9">
              <div class="float-right ml-1">
                <a (click)="viewQuotes()" class="btn btn-bidit-navigate" i18n>View Quotes</a>
              </div>
              <div class="float-right">
                <div *ngIf="defaultDate; then defaultDateBlock else customDateBlock"></div>
                <ng-template #defaultDateBlock>
                  <div class="col-md-6 dashboard-header-filter">
                    <span i18n>Last Month</span>
                    <input type="checkbox" [(ngModel)]="currentMonth" name="currentMonth" id="currentMonth"
                           class="bidit-switch"
                           (change)="loadDashboardSummary()" />
                    <span i18n>Current Month</span>
                    <button class="btn btn-bidit-action ml-2" (click)="showDefaultDate(false)" i18n>Specific Date Range</button>
                  </div>
                </ng-template>
                <ng-template #customDateBlock>
                  <div class="col-mg-6">
                    <div class="row">
                      <div class="col-sm-4" i18n>Specific Date Range</div>
                      <div class="col-sm-4">
                        <select [(ngModel)]="customYear" name="customYear" id="customYear" class="form-control select-bidit">
                          <option *ngFor="let year of years">{{year}}</option>
                        </select>
                        <select [(ngModel)]="customMonth" name="customMonth" id="customMonth" class="form-control select-bidit">
                          <option *ngFor="let month of months" [ngValue]="month.MonthNum">{{month.MonthName}}</option>
                        </select>
                      </div>
                      <div class="col-sm-4">
                        <button class="btn btn-bidit-action" (click)="loadDashboardSummary($event)" onclick="this.blur();" i18n>Apply Filter</button>
                        <button class="btn btn-bidit-action" (click)="showDefaultDate(true)" i18n>Default Range</button>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="score-label position-relative">
                <h7 class="position-absolute" style="bottom: 0;" i18n>Quotes Won</h7>
              </div>
              <div class="card dashboard-score">
                <div class="card-header dashboard-green"></div>
                <div class="card-body dashboard-card">
                  <h2>{{summary.quotesWon}}</h2>
                  ${{summary.quotesWonAmount | number: '1.0-0'}}
                </div>
                <div class="card-footer score-card-footer"></div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="score-label position-relative">
                <h7 class="position-absolute" style="bottom: 0;" i18n>Quotes Pending</h7>
              </div>
              <div class="card dashboard-score">
                <div class="card-header dashboard-yellow"></div>
                <div class="card-body dashboard-card">
                  <h2>{{summary.quotesPending}}</h2>
                  ${{summary.quotesPendingAmount | number: '1.0-0'}}
                </div>
                <div class="card-footer score-card-footer"></div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="score-label position-relative">
                <h7 class="position-absolute" style="bottom: 0;" i18n>Quotes Lost</h7>
              </div>
              <div class="card dashboard-score">
                <div class="card-header dashboard-red"></div>
                <div class="card-body dashboard-card">
                  <h2>{{summary.quotesLost}}</h2>
                  ${{summary.quotesLostAmount | number: '1.0-0'}}
                </div>
                <div class="card-footer score-card-footer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!quoteOnly" class="col-md-6 pr-0">
      <div class="card">
        <div class="card-body bg-light">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="float-left">
                <span *ngIf="isSalesperson; else jobSummary" i18n>My Jobs</span>
                <ng-template #jobSummary i18n>Jobs</ng-template>
              </h5>
              <div class="info-icon"
                   i18n-matTooltip
                   matTooltip="Jobs are quotes that the customer has accepted"></div>
            </div>
            <div class="col-sm-6">
              <div class="float-right">
                <a (click)="viewJobs()" class="btn btn-bidit-navigate" i18n>View Jobs</a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="score-label position-relative">
                <h7 class="position-absolute" style="bottom: 0;" i18n>Jobs in Progress</h7>
              </div>
              <div class="card dashboard-score">
                <div class="card-header dashboard-green"></div>
                <div class="card-body dashboard-card">
                  <h2>{{summary.jobsInProgress}}</h2>
                  ${{summary.jobsInProgressAmount | number: '1.0-0'}}
                </div>
                <div class="card-footer score-card-footer"></div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="score-label position-relative">
                <h7 class="position-absolute" style="bottom: 0;" i18n>Jobs Scheduled</h7>
              </div>
              <div class="card dashboard-score">
                <div class="card-header dashboard-yellow"></div>
                <div class="card-body dashboard-card">
                  <h2>{{summary.jobsScheduled}}</h2>
                  ${{summary.jobsScheduledAmount | number: '1.0-0'}}
                </div>
                <div class="card-footer score-card-footer"></div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="score-label position-relative">
                <h7 class="position-absolute" style="bottom: 0;" i18n>Jobs Not Scheduled</h7>
              </div>
              <div class="card dashboard-score">
                <div class="card-header dashboard-red"></div>
                <div class="card-body dashboard-card">
                  <h2>{{summary.jobsNotScheduled}}</h2>
                  ${{summary.jobsNotScheduledAmount | number: '1.0-0'}}
                </div>
                <div class="card-footer score-card-footer"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
